import React, { Component } from "react"
import PropTypes from "prop-types"
import ReactTooltip from "react-tooltip"

import styles from "./CourierInformationTable.css"

class CourierInformationTable extends Component {
  componentDidMount() {
    ReactTooltip.rebuild()
  }

  shouldShowComponent() {
    const { courier } = this.props
    return courier.courier || courier.url || courier.phone_number || courier.courier_tracking_number
  }

  render() {
    const { courier } = this.props

    if (this.shouldShowComponent()) {
      return (
        <table className={styles.table}>
          <thead>
            <tr>
              <th colSpan="2">
                <span className="f12">courier information</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {courier.url && (
              <tr>
                <th>website</th>
                <td><a href={courier.url} target="_blank" rel="noopener noreferrer nofollow">{courier.url}</a></td>
              </tr>
            )}
            {courier.phone_number && (
              <tr>
                <th>phone</th>
                <td><a href={`tel:${courier.phone_number}`}>{courier.phone_number}</a></td>
              </tr>
            )}
            {courier.courier_tracking_number && (
              <tr>
                <th>shipment reference</th>
                <td>{courier.courier_tracking_number}</td>
              </tr>
            )}
          </tbody>
        </table>
      )
    }
    return null
  }
}

CourierInformationTable.propTypes = {
  courier: PropTypes.shape({
    courier: PropTypes.string,
    url: PropTypes.string,
    phone_number: PropTypes.string,
    courier_tracking_number: PropTypes.string,
  }).isRequired,
}

export default CourierInformationTable



// WEBPACK FOOTER //
// ./src/views/Parcel/components/Information/CourierInformationTable/CourierInformationTable.js